import { setupLocale } from "survey-core";

export var burmeseStrings = {
  pagePrevText: "နောက်သို့",
  pageNextText: "ရှေ့သို့",
  completeText: "ပြီးဆုံးပါပြီ",
  previewText: "ကြိုတင်ကြည့်ရှုရန်",
  editText: "တည်းဖြတ်ရန်",
  startSurveyText: "စတင်ရန်",
  otherItemText: "အခြား (ဖော်ပြပါ)",
  noneItemText: "ဘာမျှမရှိပါ",
  refuseItemText: "ဖြေဆိုရန်ငြင်းဆန်သည်",
  dontKnowItemText: "မသိပါ",
  selectAllItemText: "အားလုံးရွေးချယ်ပါ",
  deselectAllItemText: "အားလုံးမရွေးချယ်ပါ",
  progressText: "စာမျက်နှာ {0}/{1}",
  indexText: "{0}/{1}",
  panelDynamicProgressText: "{0}/{1}",
  panelDynamicTabTextFormat: "ပန်းနယ် {panelIndex}",
  questionsProgressText: "မေးခွန်းများ {0}/{1} ဖြေဆိုပြီးပြီ",
  emptySurvey: "ဒီစစ်တမ်းတွင် မြင်သာမေးခွန်းများမရှိပါ။",
  completingSurvey: "စစ်တမ်းကိုပြီးမြောက်စွာဖြေဆိုပေးခဲ့သည့်အတွက်ကျေးဇူးတင်ပါသည်။",
  completingSurveyBefore: "ဒီစစ်တမ်းကို မျှဝေပြီးသားဖြေဆိုထားပါသည်။",
  loadingSurvey: "စစ်တမ်းကိုလုပ်ဆောင်နေသည်...",
  placeholder: "ရွေးချယ်ပါ...",
  ratingOptionsCaption: "ရွေးချယ်ပါ...",
  value: "တန်ဖိုး",
  requiredError: "ဖြေဆိုရန်လိုအပ်ပါသည်။",
  requiredErrorInPanel: "ဖြေဆိုရန်လိုအပ်ပါသည် - အနည်းဆုံးတစ်ခုကိုဖြေဆိုပါ။",
  requiredInAllRowsError: "အတန်းအားလုံးတွင်ဖြေဆိုရန်လိုအပ်ပါသည်။",
  eachRowUniqueError: "အတန်းတိုင်းတွင်ထပ်တူဖြေဆိုမှုမရှိရပါ။",
  numericError: "တန်ဖိုးသည်ကိန်းဂဏန်းဖြစ်ရပါမည်။",
  minError: "တန်ဖိုးသည် {0} ထက်မနည်းရပါ။",
  maxError: "တန်ဖိုးသည် {0} ထက်မကျော်ရပါ။",
  textNoDigitsAllow: "ကိန်းဂဏန်းများကိုခွင့်မပြုပါ။",
  textMinLength: "အနည်းဆုံး {0} လုံးဖြည့်စွက်ပါ။",
  textMaxLength: "အများဆုံး {0} လုံးထိသာဖြည့်စွက်ပါ။",
  textMinMaxLength: "အနည်းဆုံး {0} နှင့်အများဆုံး {1} လုံးဖြည့်စွက်ပါ။",
  minRowCountError: "အနည်းဆုံး {0} အတန်းဖြည့်စွက်ပါ။",
  minSelectError: "အနည်းဆုံး {0} ရွေးချယ်ချက်များရွေးပါ။",
  maxSelectError: "အများဆုံး {0} ရွေးချယ်ချက်များသာရွေးပါ။",
  numericMinMax: "‘{0}’ သည် {1} နှင့် {2} အကြားဖြစ်ရမည်။",
  numericMin: "‘{0}’ သည် {1} ထက်မနည်းရပါ။",
  numericMax: "‘{0}’ သည် {1} ထက်မကျော်ရပါ။",
  invalidEmail: "တရားဝင်သော အီးမေးလ်လိပ်စာကိုရိုက်ထည့်ပါ။",
  invalidExpression: "အထောက်အထား {0} သည် 'true' ပြန်သင့်သည်။",
  urlRequestError: "တောင်းဆိုမှုတွင် အမှား '{0}' ဖြစ်ခဲ့သည်။ {1}",
  urlGetChoicesError: "တောင်းဆိုမှုတွင်ဒေတာမရှိပါ။ သို့မဟုတ် 'path' ပိုင်ဆိုင်မှုမှာမှားနေပါသည်။",
  exceedMaxSize: "ဖိုင်အရွယ်အစားသည် {0} ထက်မကျော်ရပါ။",
  noUploadFilesHandler: "ဖိုင်များကိုအပ်လုဒ်လုပ်၍မရနိုင်ပါ။",
  otherRequiredError: "ဖြေဆိုရန်လိုအပ်ပါသည်။ တန်ဖိုးတစ်ခုရိုက်ထည့်ပါ။",
  uploadingFile: "ဖိုင်တင်နေသည်။ မိနစ်ပိုင်းစောင့်ပြီးပြန်ကြိုးစားပါ။",
  loadingFile: "တင်နေသည်...",
  chooseFile: "ဖိုင်(များ) ရွေးချယ်ပါ...",
  noFileChosen: "ဖိုင်မရွေးရသေးပါ",
  filePlaceholder: "ဖိုင်တစ်ခုအားဤနေရာတွင်ဆွဲချပြီးအောက်တွင်ရှိသောခလုတ်ကိုနှိပ်ပါ။",
  confirmDelete: "ဤမှတ်တမ်းကိုဖျက်မည်မှာ သေချာပါသလား?",
  keyDuplicationError: "ဤတန်ဖိုးသည်ထူးခြားဖြစ်ရပါမည်။",
  addColumn: "ကော်လံထည့်ရန်",
  addRow: "တန်းထည့်ရန်",
  removeRow: "ဖယ်ရှားရန်",
  emptyRowsText: "တန်းများမရှိပါ။",
  addPanel: "အသစ်ထည့်ပါ",
  removePanel: "ဖယ်ရှားပါ",
  showDetails: "အသေးစိတ်ပြရန်",
  hideDetails: "အသေးစိတ်ဖျောက်ရန်",
  choices_Item: "အရာ",
  matrix_column: "ကော်လံ",
  matrix_row: "တန်း",
  multipletext_itemname: "စာသား",
  savingData: "ရလဒ်များကိုဆာဗာတွင်သိမ်းဆည်းနေသည်...",
  savingDataError: "အမှားတစ်ခုဖြစ်ပြီး ရလဒ်များကိုသိမ်းဆည်း၍မရနိုင်ပါ။",
  savingDataSuccess: "ရလဒ်များကိုအောင်မြင်စွာသိမ်းဆည်းပြီးပါပြီ။",
  savingExceedSize: "သင့်ဖြေဆိုမှုသည် 64KB ကျော်နေပါသည်။",
  saveAgainButton: "ထပ်ကြိုးစားရန်",
  timerMin: "မိနစ်",
  timerSec: "စက္ကန့်",
  clearCaption: "ရှင်းလင်းရန်",
  signaturePlaceHolder: "ဤနေရာတွင်လက်မှတ်ရေးပါ",
  confirmRemoveFile: "ဤဖိုင်အားဖယ်ရှားမည်မှာ သေချာပါသလား: {0}?",
  ok: "အိုကေ",
  cancel: "ပယ်ဖျက်ပါ"
};

setupLocale({ localeCode: "mm", strings: burmeseStrings, nativeName: "မြန်မာ", englishName: "Burmese" });
